import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const TXT_PLEASE_WRITE_A_MESSAGE = { fr: 'Merci de remplir le message.', en: 'Please write a message.', de: 'Bitte schreibe eine Nachricht.', es: 'Escribe un mensaje, por favor.', pt: 'Escreva uma mensagem, por favor.' };
const TXT_DOFGEN_MESSAGE_FROM_FOOTER = { fr: '[dofgen] Message depuis le footer', en: '[dofgen] Message from footer', de: '[dofgen] Nachricht aus dem Footer', es: '[dofgen] Mensaje desde el pie de página', pt: '[dofgen] Mensagem do rodapé' };
const TXT_YOUR_EMAIL_CLIENT_WILL_OPEN_SO_Y = { fr: 'Votre client mail va s’ouvrir pour envoyer le message.', en: 'Your email client will open so you can send the message.', de: 'Dein E-Mail-Programm wird geöffnet, um die Nachricht zu senden.', es: 'Tu cliente de correo se abrirá para enviar el mensaje.', pt: 'O seu cliente de e-mail será aberto para enviar a mensagem.' };
const TXT_DOFGEN_ON_DISCORD = { fr: 'dofgen sur Discord', en: 'dofgen on Discord', de: 'dofgen auf Discord', es: 'dofgen en Discord', pt: 'dofgen no Discord' };
const TXT_COME_SUGGEST_CHANGES_REPORT_BUGS = { fr: 'Viens suggérer des changements, remonter des bugs et suivre le projet avec d\'autres theorycrafteurs.', en: 'Come suggest changes, report bugs and follow the project with other theorycrafters.', de: 'Schlage Änderungen vor, melde Bugs und verfolge das Projekt gemeinsam mit anderen Theorycraftern.', es: 'Ven a sugerir cambios, reportar bugs y seguir el proyecto con otros theorycrafters.', pt: 'Venha sugerir mudanças, reportar bugs e acompanhar o projeto com outros theorycrafters.' };
const TXT_FOLLOW_PROJECT_PROGRESS_OR_CONTA = { fr: 'Suis les avancées du projet ou contacte-moi directement sur Twitter. Les retours sont les bienvenus.', en: 'Follow project progress or contact me directly on Twitter. Feedback is welcome.', de: 'Verfolge den Fortschritt des Projekts oder kontaktiere mich direkt auf Twitter. Feedback ist willkommen.', es: 'Sigue los avances del proyecto o contáctame directamente en Twitter. Se agradecen los comentarios.', pt: 'Acompanhe o progresso do projeto ou fale comigo diretamente no Twitter. Feedback é bem-vindo.' };
const TXT_SUPPORT_ME_ON_KO_FI = { fr: 'Me soutenir sur Ko-fi', en: 'Support me on Ko‑fi', de: 'Unterstütze mich auf Ko-fi', es: 'Apóyame en Ko-fi', pt: 'Me apoie no Ko-fi' };
const TXT_SUPPORT_THE_PROJECT = { fr: 'Me soutenir', en: 'Support the project', de: 'Projekt unterstützen', es: 'Apoyar el proyecto', pt: 'Apoiar o projeto' };
const TXT_DOFGEN_IS_A_SOLO_AND_FREE_PROJEC = { fr: 'dofgen est un projet solo et gratuit. Si tu souhaites m\'aider à le garder en ligne, une donation via Ko-fi m\'aiderait beaucoup !', en: 'dofgen is a solo and free project. If you want to help me keep it online, a donation via Ko-fi would be greatly appreciated!', de: 'dofgen ist ein kostenloses Ein-Personen-Projekt. Wenn du helfen möchtest, es online zu halten, würde mir eine Spende über Ko-fi sehr helfen!', es: 'dofgen es un proyecto en solitario y gratuito. Si quieres ayudarme a mantenerlo en línea, ¡una donación por Ko-fi me ayudaría mucho!', pt: 'O dofgen é um projeto solo e gratuito. Se quiser me ajudar a mantê-lo no ar, uma doação via Ko-fi ajudaria muito!' };
const TXT_SEND_ME_AN_EMAIL = { fr: 'M\'envoyer un email', en: 'Send me an email', de: 'Mir eine E-Mail schicken', es: 'Enviarme un email', pt: 'Me enviar um e-mail' };
const TXT_NAME = { fr: 'Nom', en: 'Name', de: 'Name', es: 'Nombre', pt: 'Nome' };
const TXT_EMAIL = { fr: 'Email', en: 'Email', de: 'E-Mail', es: 'Email', pt: 'E-mail' };
const TXT_YOUR_MESSAGE = { fr: 'Ton message...', en: 'Your message...', de: 'Deine Nachricht...', es: 'Tu mensaje...', pt: 'Sua mensagem...' };
const TXT_SEND = { fr: 'Envoyer', en: 'Send', de: 'Senden', es: 'Enviar', pt: 'Enviar' };
const TXT_PARTNER_SITES = { fr: 'Sites partenaires', en: 'Partner sites', de: 'Partnerseiten', es: 'Sitios asociados', pt: 'Sites parceiros' };
const TXT_ANKAMA_CONTENT = { fr: 'Tout le contenu issu de Dofus est la propriété d\'Ankama Games. dofgen est un projet non officiel, sans lien avec Ankama.', en: 'All Dofus content is the property of Ankama Games. dofgen is an unofficial project, unaffiliated with Ankama.', de: 'Alle Dofus-Inhalte sind Eigentum von Ankama Games. dofgen ist ein inoffizielles Projekt ohne Verbindung zu Ankama.', es: 'Todo el contenido de Dofus es propiedad de Ankama Games. dofgen es un proyecto no oficial, sin vínculo con Ankama.', pt: 'Todo o conteúdo do Dofus é propriedade da Ankama Games. O dofgen é um projeto não oficial, sem ligação com a Ankama.' };
const TXT_SKIN_RENDER_CREDIT_BEFORE = { fr: 'Rendu des skins via ', en: 'Skin rendering via ', de: 'Skin-Rendering via ', es: 'Renderizado de skins vía ', pt: 'Renderização de skins via ' };
const TXT_SKIN_RENDER_CREDIT_LINK = { fr: 'd3-ts-renderer', en: 'd3-ts-renderer', de: 'd3-ts-renderer', es: 'd3-ts-renderer', pt: 'd3-ts-renderer' };
const TXT_COPYRIGHT = { fr: '© 2026 Luje — dofgen.com. Tous droits réservés.', en: '© 2026 Luje — dofgen.com. All rights reserved.', de: '© 2026 Luje — dofgen.com. Alle Rechte vorbehalten.', es: '© 2026 Luje — dofgen.com. Todos los derechos reservados.', pt: '© 2026 Luje — dofgen.com. Todos os direitos reservados.' };
const TXT_TERMS = { fr: 'Conditions d\'utilisation', en: 'Terms of use', de: 'Nutzungsbedingungen', es: 'Condiciones de uso', pt: 'Condições de uso' };
const SKIN_RENDER_CREDIT_URL = 'https://github.com/PyDofus/d3-ts-renderer';
const PARTNER_SITES = [
  { label: 'Codexgames', url: 'https://codexgames.net/' },
];

const Footer = ({ lang }) => {
  const [contactName, setContactName] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [contactMsg, setContactMsg] = useState('');
  const [contactStatus, setContactStatus] = useState('');

  const handleContactSubmit = (e) => {
    e.preventDefault();
    if (!contactMsg.trim()) {
      setContactStatus(TXT_PLEASE_WRITE_A_MESSAGE[lang] || TXT_PLEASE_WRITE_A_MESSAGE.en);
      return;
    }
    const subject =
      TXT_DOFGEN_MESSAGE_FROM_FOOTER[lang] || TXT_DOFGEN_MESSAGE_FROM_FOOTER.en;
    const bodyLines = [
      contactName ? `Name: ${contactName}` : '',
      contactEmail ? `Email: ${contactEmail}` : '',
      '',
      contactMsg,
    ].filter(Boolean);
    const body = encodeURIComponent(bodyLines.join('\n'));
    const mailto = `mailto:capt.luje@gmail.com?subject=${encodeURIComponent(subject)}&body=${body}`;
    window.location.href = mailto;
    setContactStatus(
      TXT_YOUR_EMAIL_CLIENT_WILL_OPEN_SO_Y[lang] || TXT_YOUR_EMAIL_CLIENT_WILL_OPEN_SO_Y.en
    );
  };

  return (
    <footer className="footer column">
      <div className="footer-content column">
        <div className="footer-main">
          <a
            href="https://discord.gg/cCs7HrECdT"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-card footer-card-discord"
          >
            <span className="footer-logo footer-logo-discord" aria-hidden="true" />
            <h5 className="footer-card-title">
              {TXT_DOFGEN_ON_DISCORD[lang] || TXT_DOFGEN_ON_DISCORD.en}
            </h5>
            <p className="footer-card-text">
              {TXT_COME_SUGGEST_CHANGES_REPORT_BUGS[lang] || TXT_COME_SUGGEST_CHANGES_REPORT_BUGS.en}
            </p>
          </a>
          <a
            href="https://twitter.com/1uje_"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-card footer-card-twitter"
          >
            <span className="footer-logo footer-logo-twitter" aria-hidden="true" />
            <h5 className="footer-card-title">@1uje_</h5>
            <p className="footer-card-text">
              {TXT_FOLLOW_PROJECT_PROGRESS_OR_CONTA[lang] || TXT_FOLLOW_PROJECT_PROGRESS_OR_CONTA.en}
            </p>
          </a>
          <div className="footer-card footer-card-donate">
            <a
              href="https://ko-fi.com/luje_"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-kofi-link"
            >
              <img
                src="/img/footer_kofi.png"
                alt={TXT_SUPPORT_ME_ON_KO_FI[lang] || TXT_SUPPORT_ME_ON_KO_FI.en}
                className="footer-kofi-badge"
              />
            </a>
            <h5 className="footer-card-title">
              {TXT_SUPPORT_THE_PROJECT[lang] || TXT_SUPPORT_THE_PROJECT.en}
            </h5>
            <p className="footer-card-text">
              {TXT_DOFGEN_IS_A_SOLO_AND_FREE_PROJEC[lang] || TXT_DOFGEN_IS_A_SOLO_AND_FREE_PROJEC.en}
            </p>
          </div>
          <div className="footer-card footer-card-contact column">
            <div className="footer-contact-copy column">
              <h5 className="footer-title">
                {TXT_SEND_ME_AN_EMAIL[lang] || TXT_SEND_ME_AN_EMAIL.en}
              </h5>
            </div>
            <form className="footer-contact-form column" onSubmit={handleContactSubmit}>
              <div className="footer-contact-row">
                <input
                  type="text"
                  className="footer-input"
                  placeholder={TXT_NAME[lang] || TXT_NAME.en}
                  value={contactName}
                  onChange={(e) => setContactName(e.target.value)}
                />
                <input
                  type="email"
                  className="footer-input"
                  placeholder={TXT_EMAIL[lang] || TXT_EMAIL.en}
                  value={contactEmail}
                  onChange={(e) => setContactEmail(e.target.value)}
                />
              </div>
              <textarea
                className="footer-input footer-textarea"
                rows={4}
                placeholder={TXT_YOUR_MESSAGE[lang] || TXT_YOUR_MESSAGE.en}
                value={contactMsg}
                onChange={(e) => setContactMsg(e.target.value)}
              />
              <div className="footer-contact-actions">
                <button type="submit" className="footer-submit-btn clickable">
                  {TXT_SEND[lang] || TXT_SEND.en}
                </button>
                {contactStatus && (
                  <div className="footer-status">
                    {contactStatus}
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
        <div className="footer-copy">
          <div className="footer-copy-col column">
            <h6 className="">
              <Link to={`/${lang}/terms`} className="footer-copy-link">
                {TXT_TERMS[lang] || TXT_TERMS.en}
              </Link>
            </h6>
            <h6 className="">
              {TXT_COPYRIGHT[lang] || TXT_COPYRIGHT.en}
            </h6>
          </div>
          <div className="footer-copy-col column">
            <h6 className="">
              {TXT_SKIN_RENDER_CREDIT_BEFORE[lang] || TXT_SKIN_RENDER_CREDIT_BEFORE.en}
              <a
                href={SKIN_RENDER_CREDIT_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-copy-link"
              >
                {TXT_SKIN_RENDER_CREDIT_LINK[lang] || TXT_SKIN_RENDER_CREDIT_LINK.en}
              </a>
              .
            </h6>
            <h6 className="">
              {TXT_ANKAMA_CONTENT[lang] || TXT_ANKAMA_CONTENT.en}
            </h6>
          </div>
          <div className="footer-copy-col column">
            <h6 className="">
              {TXT_PARTNER_SITES[lang] || TXT_PARTNER_SITES.en}
            </h6>
            {PARTNER_SITES.map((site) => (
              <h6 key={site.url}>
                <a
                  href={site.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer-copy-link"
                >
                  {site.label}
                </a>
              </h6>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

